import { Controller } from "@hotwired/stimulus";

// Shows below the personal number and the ZUK of the user form who holds the value already (users#identity),
// loaded into the hint frame of the field while typing.
export default class extends Controller {
  static values = { url: String, user: String, delay: { type: Number, default: 300 } };

  check(event) {
    const field = event.params.field;
    const value = event.target.value;

    clearTimeout(this.timeouts?.[field]);
    this.timeouts = { ...this.timeouts, [field]: setTimeout(() => this.load(field, value), this.delayValue) };
  }

  load(field, value) {
    const frame = document.getElementById(`${field}_hint`);
    if (!frame) return;

    const url = new URL(this.urlValue, window.location.origin);
    url.searchParams.set("field", field);
    url.searchParams.set("value", value);
    if (this.userValue) url.searchParams.set("user_id", this.userValue);
    frame.src = url.toString();
  }

  disconnect() {
    Object.values(this.timeouts || {}).forEach(clearTimeout);
  }
}
